import { render } from "./SearchbarComponent.vue?vue&type=template&id=7950a317&scoped=true"
const script = {}

import "./SearchbarComponent.vue?vue&type=style&index=0&id=7950a317&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7950a317"]])

export default __exports__